import React from "react";

export function EmailMagicLinkIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden
    >
      <path
        d="m31.084 11.63 2.47 1.495A3 3 0 0 1 35 15.69v17.31a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V15.671a3 3 0 0 1 1.422-2.551l2.685-1.66"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M31 19V9a5 5 0 0 0-5-5H14a5 5 0 0 0-5 5v10M35 35l-10.966-9.747A1 1 0 0 0 23.37 25h-6.74a1 1 0 0 0-.664.253L5 35"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="m5 15 10.966 9.747a1 1 0 0 0 .664.253h6.74a1 1 0 0 0 .664-.253L35 15"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M20.271 18.755a3.2 3.2 0 1 1-4.525-4.525l1.131-1.132a3.201 3.201 0 0 1 5.02.637"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M20.13 9.845a3.2 3.2 0 0 1 4.525 4.526l-1.131 1.131a3.201 3.201 0 0 1-5.02-.637"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}
